var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindowsOs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Windows_OS"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Windows_OS",
    "data-name": "Windows OS",
    clipPath: "url(#clip-Windows_OS)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "computer-screen_2426076"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M90.625,0H9.375A9.385,9.385,0,0,0,0,9.375v62.5A9.385,9.385,0,0,0,9.375,81.25H33.812l-2.084,12.5H25A3.125,3.125,0,1,0,25,100H75a3.125,3.125,0,0,0,0-6.25H68.271l-2.082-12.5H90.625A9.385,9.385,0,0,0,100,71.875V9.375A9.385,9.385,0,0,0,90.625,0ZM9.375,6.25h81.25A3.129,3.129,0,0,1,93.75,9.375V62.5H6.25V9.375A3.129,3.129,0,0,1,9.375,6.25Z",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M175.625,101.56,160,104.164v8.811h15.625Z",
    transform: "translate(-128.75 -81.724)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M287.625,82.89,272,85.493V97.951h15.625Z",
    transform: "translate(-218.875 -66.701)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M287.625,192H272v12.457l15.625,2.6Z",
    transform: "translate(-218.875 -154.5)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M175.625,192H160v8.811l15.625,2.6Z",
    transform: "translate(-128.75 -154.5)",
    fill: "#e8eaf0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsOs);
export default __webpack_public_path__ + "static/media/windows-OS.48b2f50262c132eedf366b5ffd33985d.svg";
export { ForwardRef as ReactComponent };